import type { TFunction } from "i18next";

import type { FinancialAidCard } from "./types";

/** Format a decimal-string amount as "12 000 $" (fr grouping), or null. */
function money(value: string | null): string | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return `${n.toLocaleString("fr-CA", { maximumFractionDigits: 0 })} $`;
}

/** Human-readable "montants offerts" line (étapes 3-4). */
export function formatAmounts(aid: FinancialAidCard, t: TFunction): string {
  const min = money(aid.amount_min);
  const max = money(aid.amount_max);
  if (min && max) return `${min} – ${max}`;
  if (max) return t("financialAids.card.upTo", { amount: max });
  if (min) return t("financialAids.card.from", { amount: min });
  if (aid.amount_description) return aid.amount_description;
  return t("financialAids.card.amountTbd");
}

/**
 * Human-readable "période d'admissibilité" line (étapes 3-4).
 *
 * Typed on the two dates rather than on the card, so the back-office list can
 * show the same window as the public sheet without a second implementation.
 */
export function formatEligibility(
  aid: {
    // Optional as well as nullable: the admin serializer leaves both dates out
    // of a payload that never set them, where the card always carries them.
    eligibility_start?: string | null;
    eligibility_end?: string | null;
  },
  t: TFunction,
): string {
  const { eligibility_start: start, eligibility_end: end } = aid;
  if (start && end) return `${start} – ${end}`;
  if (end) return t("financialAids.card.until", { date: end });
  if (start) return t("financialAids.card.fromDate", { date: start });
  return t("financialAids.card.always");
}
